module.exports = __webpack_public_path__ + "img/icon-update.fdc83032.svg";